import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, MenuProps } from 'antd';
import React, { useState } from 'react';
type Props = {
    folder: any;
    onSelect: Function;
    index: number;
    currentFolder: string | null
};
const EmailFolder = (props: Props) => {
    const [showSubs, setShowSubs] = useState<boolean>(true);
    const selectFolder = (folder?: any) => {
        if(props.onSelect) {
            props.onSelect(props.folder);
        }
    }
    
    const selectSubFolder = (folder?: any) => {
        if(props.onSelect) {
            props.onSelect(folder);
        }
    }
    const onMenuOptionClick = (action: string, folderName: string) => {
        console.log(action, folderName);
    }

    const buildOptionsMenu = (folder: any): any => {
        const items: MenuProps['items'] = [{
            key: 'rename',
            label: (
                <div className="pointer rtl"
                    onClick={()=>onMenuOptionClick('rename', folder.name)}
                >
                    שנה שם
                </div>
            ),
        },
        {
            label: 
                <div className="pointer rtl"
                    onClick={()=>onMenuOptionClick('delete', folder.name)}
                >
                    מחק
                </div>,
            key: 'delete',
        }];
        return {
            items: items
        }
    }

    // const items: MenuProps['items'] = [
    //     {
    //         key: 'rename',
    //         label: (
    //             <li className="pointer rtl"
    //                 onClick={()=>onMenuOptionClick('rename')}
    //             >
    //                 שנה שם
    //             </li>
    //         ),
    //     },
    //     {
    //         label: 
    //             <li className="pointer rtl"
    //                 onClick={()=>onMenuOptionClick('delete')}
    //             >
    //                 מחק
    //             </li>,
    //         key: 'delete',
    //     }
    // ];
    return (
        <>
        <div className={`emails-menu-item email-folder pointer ${props.folder.name == props.currentFolder ? 'selected' : '' }`} key={props.index}> 
            {props.folder.folders && props.folder.folders.length > 0 ? (
                <div className={`icon  ${showSubs ? 'expand-open' : 'expand-closed'}`} onClick={()=>setShowSubs(!showSubs)}></div>
            ):
            (
                <div className='icon'></div>
            )}
            <div className="label" onClick={selectFolder}>
                {props.folder.name}
            </div>
            <div className="counter">
                {props.folder.new > 0 && <span>{props.folder.new}</span>}
            </div>
            <div className='action'>
            {!props.folder.isSystemFolder ? (
                <Dropdown menu={buildOptionsMenu(props.folder)}>
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                </Dropdown>
            ) : (
                <></>
            )}
            </div>
        </div>
        {props.folder.folders && showSubs ? 
            props.folder.folders.map((folder: any, index: number) =>
            {return (
            <div className={`emails-menu-item email-folder email-sub-folder pointer ${folder.name == props.currentFolder ? 'selected' : '' }`} key={index}> 
                <div className='icon'></div>
                <div className="label" onClick={()=>selectSubFolder(folder)}>
                    {folder.name}
                </div>
                <div className="counter">
                    {folder.new > 0 && <span>{folder.new}</span>}
                </div>
                <div className='action'>
                {!folder.isSystemFolder ? (
                    <Dropdown menu={buildOptionsMenu(folder)}>
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                    </Dropdown>
                ) : (
                    <></>
                )}
                </div>
            </div>
            )}
        ) : 
        (<></>)}
        </>
    )
}
export default EmailFolder;